<script setup lang="ts">
import { RouterLink } from 'vue-router'
import logoImg from '@/assets/logo.png'
</script>

<template>
  <header class="guest-header">
    <div class="container">
      <div class="header-content">
        <!-- Logo -->
        <RouterLink to="/" class="logo-link">
          <img :src="logoImg" alt="B2B Tour Deal" />
        </RouterLink>
        
        <!-- Navigation Links -->
        
      </div>
    </div>
  </header>
</template>

<style scoped>
@import url("./GuestHeader.css");
</style>

